export default function Input({ label, error, className = '', ...props }) {
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label className="text-sm font-medium text-muted">{label}</label>
      )}
      <input
        className={`w-full px-4 py-2.5 rounded-lg text-sm outline-none transition-colors
          bg-surface2 text-fg
          ${error
            ? 'border border-red-500 focus:border-red-500'
            : 'border border-line focus:border-accent'
          } ${className}`}
        {...props}
      />
      {error && <span className="text-xs text-red-400">{error}</span>}
    </div>
  )
}
